import React from 'react';

const Camera: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M16.8477 1.50879C17.2073 1.54446 17.5485 1.68603 17.8281
      1.91504L17.9629 2.03711L18.085 2.17188C18.352 2.49797 18.4999 2.90782
      18.5 3.33301V5C18.5 5.48615 18.3066 5.9521 17.9629 6.2959C17.6588
      6.60003 17.2588 6.78525 16.834 6.82422V11.666L16.8252 12.0049C16.7415
      13.6938 16.0333 15.2966 14.832 16.498C13.5506 17.7795 11.8122 18.4999
      10 18.5C8.1878 18.4999 6.44939 17.7795 5.16797 16.498C3.96669 15.2966
      3.2595 13.6938 3.17578 12.0049L3.16699 11.666V6.82422C2.74183 6.78544
      2.34147 6.60026 2.03711 6.2959C1.73647 5.99518 1.55053 5.6011 1.50879
      5.18164L1.5 5V3.33301C1.50009 2.8469 1.69337 2.38085 2.03711
      2.03711L2.17188 1.91504C2.49797 1.64798 2.90782 1.50008 3.33301
      1.5H16.667L16.8477 1.50879ZM5.16699 11.666L5.17285 11.9062C5.23217
      13.1008 5.73329 14.2343 6.58301 15.084C7.48934 15.9902 8.71831 16.4999
      10 16.5C11.2818 16.4999 12.5116 15.9903 13.418 15.084C14.2675 14.2343
      14.7688 13.1006 14.8281 11.9062L14.834 11.666V6.83301H5.16699V11.666ZM10.2148
      7.33789C11.2859 7.39101 12.3026 7.84066 13.0645 8.60254C13.8769 9.41503
      14.3338 10.5171 14.334 11.666L14.3281 11.8809C14.2751 12.9519 13.8262
      13.9686 13.0645 14.7305C12.2519 15.543 11.1492 15.9999 10 16C8.85092
      15.9999 7.74909 15.5429 6.93652 14.7305C6.17457 13.9685 5.72492 12.952
      5.67188 11.8809L5.66699 11.666C5.66716 10.517 6.12402 9.41504 6.93652
      8.60254C7.74907 7.79016 8.851 7.33309 10 7.33301L10.2148 7.33789ZM10
      9.33301C9.38143 9.33309 8.78806 9.5793 8.35059 10.0166C7.91315 10.454
      7.66716 11.0474 7.66699 11.666L7.67871 11.8965C7.73166 12.4308 7.96759
      12.9334 8.35059 13.3164C8.78808 13.7538 9.38136 13.9999 10 14C10.6187
      13.9999 11.2129 13.7539 11.6504 13.3164C12.0878 12.8789 12.334 12.2847
      12.334 11.666L12.3223 11.4355C12.2691 10.9016 12.0331 10.3994 11.6504
      10.0166C11.2675 9.63368 10.7647 9.39773 10.2305 9.34473L10
      9.33301ZM10.1104 10.6719C10.6147 10.723 11.0088 11.1491 11.0088
      11.667C11.0086 12.1847 10.6146 12.611 10.1104 12.6621L10.0088
      12.667H10C9.44782 12.667 9.00018 12.2191 9 11.667C9 11.1147 9.44772
      10.667 10 10.667H10.0088L10.1104 10.6719Z`} fill="#98A2B3"/>
  </svg>
);

export default Camera;
